import { render, staticRenderFns } from "./Kuchis.vue?vue&type=template&id=6cc71266&"
import script from "./Kuchis.vue?vue&type=script&lang=js&"
export * from "./Kuchis.vue?vue&type=script&lang=js&"
import style0 from "./Kuchis.vue?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

component.options.__file = "Kuchis.vue"
export default component.exports